module.exports = __webpack_public_path__ + "img/l_Sketch.e083004e.svg";